export default __webpack_public_path__ + "static/media/US Investors Seek International  Fintechs.1b763d73.pdf";